import { useContext, useEffect, useRef, useState } from "react";
import { LockFill, Download, Upload } from "react-bootstrap-icons";
import Authentication from "../../../../../libs/api/services/Authentication";
import Questionnaire from "../../../../../libs/api/services/Questionnaire";
import Migration from "../../../../../libs/api/services/Migration";
import QuestionnaireConfigContext from "../QuestionnaireConfigProvider";
import CommonFunctionsContext from "../../../../common/CommonFunctionsProvider";

export default function QBuilderSetupType({
  title,
  description,
  navigation,
  navigator,
  errors,
  setValue,
  values,
}) {
  const { showConfirm } = useContext(CommonFunctionsContext);
  const { setActiveQuestionnaire } = useContext(QuestionnaireConfigContext);
  const [configurationName, setConfigurationName] = useState("");
  const [configurations, setConfigurations] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [mode, setMode] = useState("");
  const newSectionNameRef = useRef();
  const fileInputRef = useRef();
  const [configuration, setConfiguration] = useState(
    Object.keys(values).includes("questionnaireId")
      ? { id: values.questionnaireId }
      : undefined
  );
  useEffect(() => {
    title("Questionnaire Builder");
    description(
      "Would you like to create a new questionnaire or update an existing one"
    );
    // Load Navigation if session started
    if (Object.keys(values).includes("questionnaireId")) {
      navigation([
        {
          text: "Remove",
          type: "Action",
          action: async () => {
            //  _handleRemoveTemplate(values.questionnaireId).then((r) => { navigation([]); loadConfigs() })
            showConfirm({
              title: "Remove Questionnaire",
              message: "Are you sure you want to remove this questionnaire?",
              onConfirm: async () => {
                await Questionnaire.RemoveQuestionnaire(values.questionnaireId);
                setValue({
                  questionnaireId: undefined,
                  questionnaire: undefined,
                });
                setConfiguration(undefined);
                setConfigurationName("");
                navigation([]);
                loadConfigs() 
              },
              onCancel: () => {},
              option: {
                cancel: "Cancel",
                confirm: "Remove",
                },
              children: 'Are you sure you want to remove the questionnaire "' +
                values.questionnaire + '"?'
            });
          },
        },
        {
          text: "Update",
          type: "Next",
          action: async () => {
            setValue({ questionnaireId: values.questionnaireId });
          },
        },
      ]);
      setValue({ section: undefined });
    } else {
      navigation([]);
      setValue({ section: undefined });
    }
  }, []);

  const loadConfigs = (_showSystem) => _handleSetSelection("Approved");
  //     {
  //     Questionnaire
  //         .ListQuestionnairesByType(_showSystem ? 'System' : showSystem ? 'System' : 'Questionnaire')
  //         .then((r) =>
  //             setConfigurations(r)).catch((e) => errors(e.message))
  // }

  // useEffect(() => {
  //     loadConfigs(showSystem)
  // }, [showSystem])

  // useEffect(() => {
  //     loadConfigs()
  // }, [])

  const _handleSetConfigrationNameEvents = (e) => {
    if (e.keyCode === 13) {
      Questionnaire.CreateQuestionnaire({
        name: configurationName,
        type: "Questionnaire",
      }).then((r) => {
        setValue({ questionnaireId: r.id, questionnaire: configurationName });
        navigator.goto(2);
      });
    } else if (e.keyCode === 27) {
      newSectionNameRef.current.blur();
      _handleSetConfigrationName("");
    }
  };

  const exportToFile = async () => {
    try {
  const questionnaires = await Migration.ExportQuestionnaires();
  const questionnaireIds = (questionnaires || []).map((q) => q.id || q.id);
  const workflows = await Migration.ExportWorkflowsForQuestionnaires(questionnaireIds);
  const payload = JSON.stringify({ questionnaires, workflows }, null, '\t');
      const blob = new Blob([payload], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'questionnaires.json';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      errors(e.message || e);
    }
  };

  const exportSelected = async () => {
    try {
      if (!selectedIds || selectedIds.length === 0) return;
      // fetch full questionnaire payloads for each selected id
  const qs = await Promise.all(selectedIds.map((id) => Questionnaire.GetQuestionnaire(id)));
  const qIds = qs.map((q) => q.id || q.id);
  const workflows = await Migration.ExportWorkflowsForQuestionnaires(qIds);
  const payload = JSON.stringify({ questionnaires: qs, workflows }, null, "\t");
      const blob = new Blob([payload], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "questionnaires-selected.json";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      // clear selection after export
      setSelectedIds([]);
    } catch (e) {
      errors(e.message || e);
    }
  };

  const importFromFile = () => {
    if (fileInputRef && fileInputRef.current) fileInputRef.current.click();
  };

  const _handleFileSelected = (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = async (ev) => {
      try {
        const text = ev.target.result;
        // Send raw text to import endpoint (server expects JSON string)
        await Migration.ImportQuestionniares(text);
        loadConfigs();
      } catch (err) {
        errors(err.message || err);
      }
    };
    reader.readAsText(f);
    // reset input so same file can be selected again if needed
    e.target.value = '';
  };
  const _handleSetConfigrationName = (c) => {
    setConfigurationName(c);
    if (c)
      navigation([
        {
          text: "Next",
          type: "Next",
          action: async () => {
            return await Questionnaire.CreateQuestionnaire({
              name: c,
              type: "Questionnaire",
            }).then((r) => {
              setValue({ questionnaireId: r.id, questionnaire: c });
            });
          },
        },
      ]);
    else navigation([]);
    setConfiguration();
  };

  const _handleRemoveTemplate = async (id) => {
    await Questionnaire.RemoveQuestionnaire(id);
  };

  const _handleSelectConfiguration = (c) => {
    setActiveQuestionnaire(c, () => _handleSetSelection("Awaiting Approval"));
    if (c)
      if (c.isLocked)
        navigation([
          //   { text: 'Remove', type: 'Action', action: async () => { _handleRemoveTemplate(c.id).then((r) => { navigation([]); loadConfigs() }) } },
          {
            text: "Update",
            type: "Next",
            action: async () => {
              setValue({ questionnaireId: c.id, templateName: c.name });
            },
          },
        ]);
      else
        navigation([
          {
            text: "Remove",
            type: "Action",
            action: async () => {
              _handleRemoveTemplate(c.id).then((r) => {
                navigation([]);
                loadConfigs();
              });
            },
          },
          {
            text: "Update",
            type: "Next",
            action: async () => {
              setValue({ questionnaireId: c.id, templateName: c.name });
            },
          },
        ]);
    setConfigurationName("");
    setConfiguration(c);
  };

  

  const _handleSetSelection = (e) => {
    // switch (e) {
    //     case 'System Surveys': setShowSystem(true); break;
    //     case 'Awaiting Approval': setShowSystem(false); break;
    //     case 'System Surveys': setShowSystem(false); break;
    //     default: break;
    // }
    Questionnaire.ListQuestionnairesByTypeOpts(
      e === "System Surveys" ? "System" : "Questionnaire",
      {
        isApproved: e === "Approved",
        isAlocate: Authentication.getFacility() !== "-1",
      }
    )
      .then((r) => setConfigurations(r))
      .catch((e) => errors(e.message));
    setMode("Update");
  };

  return (
    <div className="config-setup-type">
      <div className="d-flex justify-content-end mb-2">
        <button className="btn btn-sm me-2" onClick={exportToFile} title="Export all questionnaires">
          <Download className="me-1" /> Export All
        </button>
        <button className="btn btn-sm me-2" onClick={exportSelected} title="Export selected questionnaires">
          <Download className="me-1" /> Export Selected
        </button>
        <button className="btn btn-sm me-2" onClick={importFromFile} title="Import questionnaires">
          <Upload className="me-1" /> Import
        </button>
        <input ref={fileInputRef} onChange={_handleFileSelected} type="file" accept="application/json" style={{ display: 'none' }} />
      </div>
      <div
        className={"row top p-3 shadow rounded bg-primary-container ".concat(
          mode !== "New" && configurationName === "" ? "opacity-75" : ""
        )}
      >
        <div className="col-12">
          <h3>New?</h3>
          <p>
            Enter a name for the Questionnaire eg: Patient Discharge
            Questionnaire
          </p>
          <input
            ref={newSectionNameRef}
            onFocus={(e) => setMode("New")}
            onBlur={(e) => setMode("")}
            onChange={(e) => _handleSetConfigrationName(e.target.value)}
            onKeyDown={(e) => _handleSetConfigrationNameEvents(e)}
            value={configurationName}
            className="form-control"
            placeholder="Name of the new survey eg: Patient Discharge Survey"
          />
        </div>
      </div>
      <div
        className={"row bottom p-3 flex-grow-1 shadow mb-3 rounded bg-secondary-container ".concat(
          mode !== "New" && configuration ? "" : " opacity-75"
        )}
      >
        <div className="col-12" style={{ height: "calc(100% - 30px)" }}>
          <h3>Update Existing?</h3>
          <p>Select the questionnaire you would like to update</p>
          <SectionSelectorTabs onChange={_handleSetSelection} />
          <div
            style={{ cursor: "pointer", maxHeight: "75%", overflow: "auto" }}
            className="text-start"
          >
            {configurations &&
              configurations.map((c) => (
                <div
                  className={"p-2 d-flex rounded align-items-center ".concat(
                    configuration && c.id === configuration.id
                      ? " font-weight-bold active "
                      : " font-weight-light "
                  )}
                >
                  <input
                    type="checkbox"
                    className="me-2"
                    checked={selectedIds.includes(c.id)}
                    onChange={(e) => {
                      if (e.target.checked) setSelectedIds([...selectedIds, c.id]);
                      else setSelectedIds(selectedIds.filter((id) => id !== c.id));
                    }}
                  />
                  <div style={{ cursor: 'pointer' }} onClick={() => _handleSelectConfiguration(c)} className="flex-grow-1 d-flex align-items-center">
                    {c.isLocked ? <LockFill className="me-2" /> : <></>}
                    <div>{c.name}</div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const SectionSelectorTabs = ({ onChange }) => {
  const [selected, setSelected] = useState({ opt: "Approved" });
  const Options = [
    { opt: "Approved", hr: "Approved" },
    { opt: "Awaiting Approval", hr: "Awaiting Approval", super: false },
    { opt: "System Surveys", hr: "System Surveys", super: true },
  ];
  useEffect(() => {
    if (selected && onChange) onChange(selected.opt);
  }, [selected]);
  return (
    <div className="d-flex">
      {Options.map((o) =>
        Authentication.getFacility() === "-1" && o.super ? (
          <button
            onClick={(e) => setSelected(o)}
            className={`btn shadow-none rounded-3 w-100 tab ${
              selected && selected.opt === o.opt ? "selected shadow " : ""
            }`}
          >
            {o.hr}
          </button>
        ) : Authentication.getFacility() !== "-1" && o.super ? (
          <></>
        ) : (
          <button
            onClick={(e) => setSelected(o)}
            className={`btn shadow-none w-100 tab ${
              selected && selected.opt === o.opt ? "selected shadow " : ""
            }`}
          >
            {o.hr}
          </button>
        )
      )}
    </div>
  );
};
